"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CreditsUsage = require("./CreditsUsage.style");
var _Link = _interopRequireDefault(require("../../../Link"));
var _Text = _interopRequireDefault(require("../../../Text"));
const CreditsUsage = _ref => {
  var _data$credits;
  let {
    link,
    data
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_CreditsUsage.CreditsUsageWrapper, {
    "data-testid": "credits-usage"
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    to: link
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    intlText: "HeaderMenus.Main.CreditsUsage"
  }), data.loading ? /*#__PURE__*/_react.default.createElement(_CreditsUsage.CreditCountSkeleton, {
    width: 60
  }) : /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "ButtonText",
    text: " ".concat((data === null || data === void 0 ? void 0 : (_data$credits = data.credits) === null || _data$credits === void 0 ? void 0 : _data$credits.count) || 0)
  })));
};
var _default = exports.default = CreditsUsage;